import React from 'react';
import { Box } from '@mui/material';
import CustomTitleWithBlueBackground from '../../common/CustomTitleWithBlueBackground';
import InstructionsNumberedList from './InstructionsNumberedList';

const instructionsOne = [
  'Check the contents of the kit against the list shown on the instructions.',
  'Uncap one of the lancets by twisting the cap off.',
  "Tear open the sample bag and take out the sampler cartridge. Open the sampler cartridge by clicking the tabs open. Please don't throw away the desiccant card.",
];

const instructionsTwo = [
  'Open the alcohol wipe, gauze, and adhesive bandages and place them next to the lancet and sampler ready to use later.',
  'Wash your hands with soap and warm water. Dry them thoroughly.',
  'Warm your hands by rubbing together for 30s. If you have poor circulation, you should also walk around a bit waving your hands in small circles at waist level.',
];

const TakeYourTestInstructions = () => {
  return (
    <Box sx={{ p: 0, mt: 2 }}>
      <CustomTitleWithBlueBackground text="How to take your test" gutterBottom={false} parentSxProps={{ mb: 2 }} />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: { md: 3 },
        }}
      >
        <Box>
          <InstructionsNumberedList lists={instructionsOne} />
        </Box>
        <Box>
          <InstructionsNumberedList lists={instructionsTwo} startingIndex={3} />
        </Box>
      </Box>
    </Box>
  );
};

export default TakeYourTestInstructions;
